import { ChangeEvent, useState } from "react";
import { resources } from "@constants/hardcoded-strings";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { VerificationServiceChangeRequest } from "@idw-types/data/verification-service";
import { TextareaFormGroup } from "@containers/common/textarea-form-group/textarea-form-group";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";

type RejectVerificationServiceChangeRequestModalProps = {
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void, data: string) => Promise<VerificationServiceChangeRequest>;
};

export const RejectVerificationServiceChangeRequestModal = (props: RejectVerificationServiceChangeRequestModalProps) => {
    const { onModalClose, onSubmitHandler } = props;
    const [comments, setComments] = useState("");

    const handleCommentsChange = (event: ChangeEvent<HTMLInputElement>) => {
        setComments(event.target.value);
    };

    const bodyElement = (
        <div>
            <p>{resources.modals.rejectVerificationServiceChangeRequest.description}</p>
            <TextareaFormGroup
                controlId="reject-change-request-comments"
                disabled={false}
                isRequired={false}
                label={resources.modals.rejectVerificationServiceChangeRequest.inputs.rejectionComments.label}
                onChange={handleCommentsChange}
                value={comments}
            />
        </div>
    );

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose, comments);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.REJECT}
            title={resources.modals.rejectVerificationServiceChangeRequest.title}
            body={bodyElement}
            buttonText={resources.modals.rejectVerificationServiceChangeRequest.buttonText}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};